
export class GameSeriesDTO {
	public mainVideo: string;
	public playList: string;
	public placeHolder: boolean;
	public videos: string[];
}
